import React from 'react';
import { I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Tooltip,
} from '@material-ui/core';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import { notify } from '../../Notifier/services/actions';
import './style.scss';

/**
 * Popup "Identifiant et token du partenaire" — base neuve, alimentée par
 * partner.infos (mêmes clés que partner.popupInfo.*).
 *
 * Chaque info est sur sa propre ligne, valeur affichée en entier et copiable
 * d'un clic (les chaînes longues type token ne sont plus à sélectionner à la
 * main).
 *
 * @param {Boolean} props.open
 * @param {String}  props.partnerName
 * @param {Object}  props.infos couples clé -> valeur
 * @param {Function} props.onClose
 */
const PartnerInfoDialog = ({ open, partnerName, infos, onClose, notify }) => {
	const keys = Object.keys(infos || {});

	const copyToClipboard = value => {
		if (navigator.clipboard && value != null) {
			navigator.clipboard.writeText(value);
			notify(I18n.t('partner.copied'), 'success');
		}
	};

	return (
		<Dialog open={open} onClose={onClose} className="partner-info">
			<DialogTitle className="partner-info__title">
				{I18n.t('general.information')}
				{partnerName ? ` — ${partnerName}` : ''}
			</DialogTitle>

			<DialogContent className="partner-info__content">
				{keys.map(key => {
					const value = infos[key];
					const label = I18n.t(`partner.popupInfo.${key}`);

					if (!value) {
						return (
							<div className="partner-info__row" key={key}>
								<span className="partner-info__label">{label}</span>
								<span className="partner-info__value partner-info__value--empty">
									{I18n.t('partner.infoUndefined')}
								</span>
							</div>
						);
					}

					return (
						<div className="partner-info__row" key={key}>
							<span className="partner-info__label">{label}</span>
							<Tooltip title={I18n.t('partner.copy')}>
								<div
									className="partner-info__copy"
									onClick={() => copyToClipboard(value)}>
									<span className="partner-info__value">{value}</span>
									<FileCopyOutlinedIcon className="partner-info__copy-icon" />
								</div>
							</Tooltip>
						</div>
					);
				})}
			</DialogContent>

			<DialogActions>
				<Button
					onClick={onClose}
					color="primary"
					variant="contained"
					className="button-valid">
					{I18n.t('general.close')}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

const mapDispatchToProps = { notify };

export default connect(null, mapDispatchToProps)(PartnerInfoDialog);
